import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { ChatEventFragment } from '@spotify/confidence-graphql';

export const ChatEventExtensions = createItemRenderExtensions<
  ItemRenderExtensionOptions<ChatEventFragment>
>({
  id: 'chat-event',
});

export const createChatEventExtension = (
  options: ItemRenderExtensionOptions<ChatEventFragment>,
) => {
  return createItemRenderExtension<
    ItemRenderExtensionOptions<ChatEventFragment>
  >(options);
};

export const useChatEventExtensions = () => {
  return useItemRenderExtensions<ItemRenderExtensionOptions<ChatEventFragment>>(
    ChatEventExtensions,
  );
};
